import * as TrayTaskConstants from './TrayTaskConstants';
import {TrayTask} from './TrayTaskConstants';

function hasTaskFailed(task: TrayTask): boolean {
  return task.progress === TrayTaskConstants.FAILURE_PROGRESS;
}

function hasTaskSucceeded(task: TrayTask): boolean {
  return task.progress === TrayTaskConstants.SUCCESS_PROGRESS;
}

function hasTaskFinished(task: TrayTask): boolean {
  return hasTaskFailed(task) || hasTaskSucceeded(task);
}

export {hasTaskFailed, hasTaskSucceeded, hasTaskFinished};
